import { render, staticRenderFns } from "./calling-messaging.svg?vue&type=template&id=257210e4"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports